import { Injectable} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';


import { HttpClientService } from './../../providers';

@Injectable()
export class TermsContentService {

 constructor(private httpClientService: HttpClientService) { }

  fetchtnc(tncUrl) {
    return this.httpClientService.get( (tncUrl: HttpResponse<any>) => { tncUrl.body }).pipe(
      catchError( this.handleError ));
  }


  handleError = (error) => {
    return throwError(error);
  };

}
